export const UPDATE_MYTRIP_LOADER = 'UPDATE_MYTRIP_LOADER';
export const UPDATE_MYTRIP_ACTIVE_TAB = 'UPDATE_MYTRIP_ACTIVE_TAB';
export const UPDATE_MYTRIP_HEADERS = 'UPDATE_MYTRIP_HEADERS';
export const UPDATE_MYTRIP_DATA = 'UPDATE_MYTRIP_DATA';
export const UPDATE_MYTRIP_DETAILS_QUERY_PARAMS = 'UPDATE_MYTRIP_DETAILS_QUERY_PARAMS';
export const UPDATE_MYTRIP_DETAILS_DATA = 'UPDATE_MYTRIP_DETAILS_DATA';
export const UPDATE_CANCELLATION_DATA = 'UPDATE_CANCELLATION_DATA';
export const UPDATE_CANCELLATION_ACTIVE_TAB = 'UPDATE_CANCELLATION_ACTIVE_TAB';
export const UPDATE_CANCELLATION_REFUND_MODE = 'UPDATE_CANCELLATION_REFUND_MODE';
export const UPDATE_CANCELLATION_REFUND_DATA = 'UPDATE_CANCELLATION_REFUND_DATA';
export const UPDATE_WALLET_DATA = 'UPDATE_WALLET_DATA';
export const UPDATE_WALLET_STATEMENT_LOADER = 'UPDATE_WALLET_STATEMENT_LOADER';
export const UPDATE_WALLET_BREAKUP_DATA = 'UPDATE_WALLET_BREAKUP_DATA';
export const UPDATE_RECHARGE_STATUS = 'UPDATE_RECHARGE_STATUS';
export const UPDATE_MODIFY_ACTIVE_TAB = 'UPDATE_MODIFY_ACTIVE_TAB';
export const UPDATE_MODIFY_HOTEL_DETAILS_DATA = 'UPDATE_MODIFY_HOTEL_DETAILS_DATA';
export const UPDATE_MODIFY_DETAILS_DATA = 'UPDATE_MODIFY_DETAILS_DATA';
export const UPDATE_MODIFY_STATUS = 'UPDATE_MODIFY_STATUS';
export const UPDATE_USER_SETTING_DATA = 'UPDATE_USER_SETTING_DATA';
export const UPDATE_SUCCESS_NAME_MESSAGE = 'UPDATE_SUCCESS_NAME_MESSAGE';
export const UPDATE_ERROR_NAME_MESSAGE = 'UPDATE_ERROR_NAME_MESSAGE';
export const UPDATE_AADHAR_NUMBER = 'UPDATE_AADHAR_NUMBER';
export const UPDATE_WALLET_TYPE = 'UPDATE_WALLET_TYPE';
export const UPDATE_NEFT_DETAILS = 'UPDATE_NEFT_DETAILS';
export const UPDATE_NEFT_DETAILS_LOADER = 'UPDATE_NEFT_DETAILS_LOADER';
export const UPDATE_LOYALTY_AGREEMENT_DATE = 'UPDATE_LOYALTY_AGREEMENT_DATE';
export const UPDATE_LOYALTY_AGREEMENT_DOC = 'UPDATE_LOYALTY_AGREEMENT_DOC';
export const UPDATE_GCC_USER_SETTING_DATA = 'UPDATE_GCC_USER_SETTING_DATA';
export const UPDATE_POPUP_TYPE = 'UPDATE_POPUP_TYPE';
export const UPDATE_FORMFIELD_DATA = 'UPDATE_FORMFIELD_DATA';

export const UPDATE_ROW_FIELDS_DATA = 'UPDATE_ROW_FIELDS_DATA';
export const UPDATE_CARDS_MEMO = 'UPDATE_CARDS_MEMO';
export const UPDATE_CARDS_DATA = 'UPDATE_CARDS_DATA';
export const UPDATE_AIS_CARDS_DATA = 'UPDATE_AIS_CARDS_DATA';
export const UPDATE_GST_FORM_ROW = 'UPDATE_GST_FORM_ROW';

export const UPCOMING = 'Upcoming Check-ins';
export const UPCOMING_KEY = 'upcoming';

export const CANCELLED = 'Cancelled';
export const CANCELLED_KEY = 'cancelled';

export const COMPLETED = 'Checked-in';
export const COMPLETED_KEY = 'completed';

export const FAILED = 'failed';
export const FAILED_KEY = 'failed';

export const ALL_TRIPS = 'all bookings';
export const ALL_TRIPS_KEY = 'allbooking';

export const STATUS_TEXT = status => {
  switch (status) {
    case UPCOMING_KEY:
      return 'Your booking is confirmed!';
    case CANCELLED_KEY:
      return 'Your booking has been cancelled';
    case COMPLETED_KEY:
      return 'Your booking is completed';
    case FAILED_KEY:
      return 'Your booking has failed';
    default:
      return '';
  }
};

export const TRIP_HEADERS = [
  {
    heading: UPCOMING,
    subheading: '',
    icon: UPCOMING_KEY,
  },
  {
    heading: CANCELLED,
    subheading: '',
    icon: CANCELLED_KEY,
  },
  {
    heading: COMPLETED,
    subheading: '',
    icon: COMPLETED_KEY,
  },
  {
    heading: ALL_TRIPS,
    subheading: '',
    icon: ALL_TRIPS_KEY,
  },
];

export const defaultActiveTab = UPCOMING_KEY;

//URLS
const host = `${__ENV_CONFIG__.MYPARTNER}`;

export const myTripsApi = `${host}/api/v1/support/trips/`;
// export const walletApi = `${host}/wallet/credit/`;
export const walletApi = `${host}/wallet/`;
export const walletBreakupApi = `${host}/wallet/balance/`;
export const rechargeWalletApi = `${host}/wallet/recharge/`;
export const cancellationApi = `${host}/api/v1/hotels/refund_amount/`;
export const refundDetailsApi = `${host}/api/v1/hotels/postrefundbreakup/`;
export const refundAmountApi = `${host}/api/v1/hotels/refundbreakup/`;
export const confirmCancellation = `${host}/api/v1/hotels/confirmcancel/`;
export const myTripsModifyHotelDetailsApi = `${host}/api/v1/hotels/get_booking_detail/`;
export const myTripsModifyApi = `${host}/api/v1/hotels/get_reschedule_detail/`;
export const confirmRescheduleApi = `${host}/api/v1/hotels/confirm_reschedule/`;
export const rescheduleStatusApi = `${host}/api/v1/hotels/amend_booking_status/`;
export const settingApi = `${host}/agents/settings/`;
export const nameChangeApi = `${host}/api/v1/hotels/namechange`;
export const aadharApi = `${host}/agents/aadhar-upload/`;
export const neftApi = `${host}/wallet/neftaccountdetails`;
export const emailVerifyApi = `${host}/agents/add_email/`;
export const unlinkMobileApi = `${host}/agents/unlink_mobile/`;
export const updateMobileApi = `${host}/agents/update_mobile/`;
export const getLoyaltyAgnApi = `${host}/agents/loyalty-tnc/`;
export const unMaskOTPApi = `${host}/agents/generate-unhide-otp/`;
export const verifyUnMaskOTPApi = `${host}/agents/verify-unhide-otp/`;
export const maskDataApi = `${host}/agents/clear-unhide-verification/`;

export const MY_TRIPS_DETAILS = '/mytrips/details/';
export const HOTELS_HOME = '/hotels/';
export const reportDownaload = `${host}/transactions/events/`;

export const getEmailVerifyApi = `${host}/agents/verify-alt-email/`;

export const updateVerifiedEmail = `${host}/agents/update-alt-email/`;

export const refundRaiseRequestListing = `${host}/wallet/neft-deposit-request?searchStartDate=`;
export const refundRaiseRequest = `${host}/wallet/neft-deposit-request`;

//tds update
export const updateTdsSlabUrl = `${host}/agents/update-tds-slab`;
export const gccMyProfile = `${host}/agents/gcc-settings/`; //GCC My Profile endpoint

//New Agreement
export const getUserAgnApi = `${host}/agents/user-agreement/`;

//GST Invoice api
export const getGstinDetails = `${host}/transactions/gst-commission-earning`;
export const deleteGstUser = `${host}/agents/delete-traveller-gst`;
export const commissionBreakupApi = `${host}/commission/getsubmitdetails?start_date=`;
export const commsionInvoiceDocumentUpload = `${host}/commission/validatecommissionreport`;
export const commsionInvoiceDetails = `${host}/commission/submitcommissionreport`;
export const trackCommissionReport = `${host}/commission/trackcommissionreport`;
export const UPDATE_LICENSE_DETAILS = `${host}/gcc/update-trade-license/`;

//AIS PROFILE
export const GET_PROFILE_PAGE_DATA = `${host}/agents/supplier-settings`;
export const DOWNLOAD_CREDIT_MEMO = `${host}/commission/download-credit-memo`;
